<template>
  <div>
    <b-row>
      <!--WEB SERVICE-->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="host" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="port" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <label>
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="sslActive" :disabled="readonly">
          <option value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0" selected> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!uriPathHasPipe">
        <form-write-group-label-input v-model="uri" :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.uri')" :placeholderValue="$t('common.routing.uri')">
        </form-write-group-label-input>
      </b-col>
      <template v-for="(path, index) in uriPathArray" v-else>
        <b-col sm="6" class="form-group" :key="path + '-' + index">
          <form-write-group-label-input v-model="path.access" @input="changeUri" :disabled="readonly" :maxLength="512"
            :inputLabel="selectPathUriLabel(path, index)" :placeholderValue="$t('common.routing.uri')">
            <b-form-checkbox slot="label-slot" v-if="path.active && path.active !== '-1'" @change="changeUriActive"
              v-model="path.active"
              class="ml-5"
              :disabled="readonly"
              value="1"
              unchecked-value="0">
              {{$t('common.routing.uriActivation')}}
            </b-form-checkbox>
          </form-write-group-label-input>
        </b-col>
      </template>
    </b-row>
    <form-accordion title="Token credentials" :isTitleUpperCase="false" v-if="login && password">
      <b-row>
        <b-col cols="6" class="fake-hr-right px-0">
          <b-col class="form-group">
            <form-write-group-label-input v-model="loginStorage" :disabled="true" :maxLength="512" inputType="select"
              :inputLabel="$t('common.routing.loginStorage')">
              <select class="form-control" v-model="loginStorage" :disabled="true">
                <option value="">{{ $t('common.routing.volume_select') }}</option>
                <option value="PEM">{{ 'PEM' }}</option>
                <option value="FILE">{{ 'Volume' }}</option>
                <option value="Vault">{{ 'Vault' }}</option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="loginFile" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.loginFile')" :placeholderValue="$t('common.routing.loginFile')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label>Variable</label>
                <b-form-radio-group v-model="loginFileType" :disabled="true">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="loginYAML" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.loginYAML')" :placeholderValue="$t('common.routing.loginYAML')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label>Variable</label>
                <b-form-radio-group v-model="loginYAMLType" :disabled="true">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>

        </b-col>
        <b-col cols="6" class="px-0">
          <b-col class="form-group">
            <form-write-group-label-input v-model="passwordStorage" :disabled="true" :maxLength="512" inputType="select"
              :inputLabel="$t('common.routing.passwordStorage')">
              <select class="form-control" v-model="loginStorage" :disabled="true">
                <option value="">{{ $t('common.routing.volume_select') }}...</option>
                <option value="PEM">{{ 'PEM' }}</option>
                <option value="FILE">{{ 'Volume' }}</option>
                <option value="Vault">{{ 'Vault' }}</option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="passwordFile" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.passwordFile')" :placeholderValue="$t('common.routing.passwordFile')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label>Variable</label>
                <b-form-radio-group v-model="passwordFileType" :disabled="true">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="passwordYAML" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.passwordYAML')" :placeholderValue="$t('common.routing.passwordYAML')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label>Variable</label>
                <b-form-radio-group v-model="passwordYAMLType" :disabled="true">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </form-accordion>
    <!--<level-control-form v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementWebService"></level-control-form>
    <certificate-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="certificateConfig" :placementCertificate="placementWebService"></certificate-form-global>
    <private-keys-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="privateKeysConfig" :placementPrivateKey="placementWebService"></private-keys-form-global>-->
  </div>
</template>
<script>

import CertificateFormGlobal from '@/pages/routing/global/CertificateFormGlobal.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import PrivateKeysFormGlobal from '@/pages/routing/global/PrivateKeysFormGlobal.vue'

export default {
  name: 'WebServiceConfigurationForm',
  components: {
    'certificate-form-global': CertificateFormGlobal,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm,
    'private-keys-form-global': PrivateKeysFormGlobal
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name: {
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          name: val,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    host: {
      get () {
        return this.inputValue.host
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: val,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    port: {
      get () {
        return this.inputValue.port
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: val,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    uri: {
      get () {
        return this.inputValue.uri
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: val,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    uriActive: {
      get () {
        return this.inputValue.uriActive
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: val,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    uriLabel: {
      get () {
        return this.inputValue.uriLabel
      }
    },
    sslActive: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.sslActive
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: val,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: val,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: val,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: val,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    login: {
      get () {
        return this.inputValue.login
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: val,
          password: this.inputValue.password
        }
      }
    },
    loginStorage: {
      get () {
        let storageMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    loginFile: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },
    loginFileType: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    loginYAML: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    loginYAMLType: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    password: {
      get () {
        return this.inputValue.password
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          uriActive: this.inputValue.uriActive,
          uriLabel: this.inputValue.uriLabel,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          login: this.inputValue.login,
          password: val
        }
      }
    },
    passwordStorage: {
      get () {
        let storageMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    passwordFile: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },

    passwordFileType: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    passwordYAML: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    passwordYAMLType: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    uriPathHasPipe () {
      return this.uri.includes('|')
    }
  },
  data () {
    return {
      uriPathArray: []
    }
  },
  created () {
    if (this.mode === 'create') {
      if (this.prefilledURI !== undefined || this.prefilledURI === '') {
        this.inputValue.uri = this.prefilledURI
      }
      this.inputValue.sslActive = "0"
    }
    if (this.uri.length > 0 && this.uriPathHasPipe) {
      let accessArray = this.uri.split('|')
      let activeArray = this.uriActive.split('|')
      let labelArray = this.uriLabel.split('|')
      this.uriPathArray = accessArray.map((_, i) => ({
        access: accessArray.length > i ? accessArray[i] : undefined,
        active: activeArray.length > i ? activeArray[i] : undefined,
        label: labelArray.length > i ? labelArray[i] : undefined,
      }))
    }
  },
  methods: {
    changeUri () {
      this.uri = this.uriPathArray.map(elem => elem.access).join('|')
    },
    changeUriActive () {
      this.uriActive = this.uriPathArray.map(elem => elem.active).join('|')
    },
    selectPathUriLabel (path, index) {
      if (!path.label || this.$i18n.t('common.routing.uriLabel.' + path.label) === 'common.routing.uriLabel.' + path.label) {
        return this.$i18n.t('common.routing.uri') + ' ' + (index + 1)
      }
      return this.$i18n.t('common.routing.uriLabel.' + path.label)
    }
  }
}

</script>
